var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.36115C8 1.42183 7.97938 1.48251 7.91753 1.54319L4.18557 5.20439C4.12371 5.26507 4.06186 5.2853 4 5.2853C3.93814 5.2853 3.87629 5.26507 3.81443 5.20439L0.082473 1.54319C0.0206173 1.48251 0 1.42183 0 1.36115C0 1.30046 0.0206173 1.23978 0.082473 1.1791L0.474224 0.794776C0.53608 0.734094 0.597935 0.713867 0.65979 0.713867C0.721646 0.713867 0.783507 0.734094 0.845362 0.794776L4 3.88959L7.15464 0.794776C7.21649 0.734094 7.27835 0.713867 7.34021 0.713867C7.40207 0.713867 7.46392 0.734094 7.52578 0.794776L7.91753 1.1791C7.95876 1.23978 8 1.30046 8 1.36115Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.ee7d84d9e6d44c61d08ee1c8b4ddab3d.svg";
export { ForwardRef as ReactComponent };